<template>
  <Headers :type="prop.type" :countDown="prop.countDown"> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <PogressBarStep :cardName="prop.cardName" :currentStep="4">
    </PogressBarStep>
    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div :class="[deviceType, 'inner']">
        <div :class="[deviceType, 'content']">
          <div v-if="prop.type != 'PF_CC'" :class="[deviceType, 'separator']">
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <div :class="[deviceType, 'margin']">
                  <DropDown
                    v-model="prop.personalInformation.title"
                    :selectedOption="prop.personalInformation.title"
                    :options="titleList"
                    :value="titleList"
                    field="title"
                    :placeholder="t('ccOnBoarding.personalInformation.title')"
                  />
                </div>
              </div>
              <div :class="[deviceType, 'flex_half']">
                <DropDown
                  v-model="prop.personalInformation.gender"
                  :selectedOption="prop.personalInformation.gender"
                  :options="genderList"
                  :value="genderList"
                  field="gender"
                  :placeholder="t('ccOnBoarding.personalInformation.gender')"
                  :disabled="disabledField || prop.isAutoPopulate"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container']">
              <div
                v-if="prop.nationality == 'MY'"
                :class="[deviceType, 'flex_half']"
              >
                <div :class="[deviceType, 'margin']">
                  <DropDown
                    v-model="prop.personalInformation.race"
                    :selectedOption="prop.personalInformation.race"
                    :options="raceList"
                    :value="raceList"
                    field="race"
                    :placeholder="t('ccOnBoarding.personalInformation.race')"
                    :disabled="prop.isAutoPopulate"
                  />
                </div>
              </div>

              <div
                v-if="
                  prop.nationality == 'MY' &&
                  prop.personalInformation.race == '004'
                "
                :class="[deviceType, 'flex_race']"
              >
                <InputText
                  class="inputcomponent"
                  v-model="prop.personalInformation.otherRace"
                  field="otherRace"
                  :required="false"
                  :placeholder="t('ccOnBoarding.personalInformation.otherRace')"
                  :max-length="20"
                  :autocomplete="'new-password'"
                />
              </div>

              <div
                v-else-if="prop.nationality != 'MY'"
                :class="[deviceType, 'dropDown']"
              >
                <div :class="[deviceType, 'margin']">
                  <DropDown
                    v-model="prop.personalInformation.race"
                    :selectedOption="prop.personalInformation.race"
                    :options="raceList"
                    :value="raceList"
                    field="race"
                    :placeholder="t('ccOnBoarding.personalInformation.race')"
                    :disabled="prop.isAutoPopulate"
                  />
                </div>
              </div>
              <div
                v-if="
                  prop.nationality != 'MY' &&
                  prop.personalInformation.race == '004'
                "
                :class="[deviceType, 'dropDown']"
              >
                <InputText
                  class="inputcomponent"
                  v-model="prop.personalInformation.otherRace"
                  field="otherRace"
                  :required="false"
                  :placeholder="t('ccOnBoarding.personalInformation.otherRace')"
                  :max-length="20"
                  :autocomplete="'new-password'"
                />
              </div>
              <div
                v-if="prop.nationality == 'MY'"
                :class="[deviceType, 'flex_half']"
              >
                <DropDown
                  v-model="prop.personalInformation.residencyStatus"
                  :selectedOption="prop.personalInformation.residencyStatus"
                  :options="residencyList"
                  :value="residencyList"
                  field="residencyStatus"
                  :placeholder="
                    t('ccOnBoarding.personalInformation.residencyStatus')
                  "
                  :default="true"
                  :default-value="defaultResidency"
                  :disabled="prop.isAutoPopulate"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <div :class="[deviceType, 'margin']">
                  <DropDown
                    v-model="prop.personalInformation.maritalStatus"
                    :selectedOption="prop.personalInformation.maritalStatus"
                    :options="maritalList"
                    :value="maritalList"
                    field="maritalSatus"
                    :placeholder="
                      t('ccOnBoarding.personalInformation.maritalStatus')
                    "
                  />
                </div>
              </div>
              <div :class="[deviceType, 'flex_half']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.personalInformation.motherMaidenName"
                  field="motherMaidenName"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.personalInformation.motherMaidenName')
                  "
                  :max-length="100"
                  :autocomplete="'new-password'"
                  @keydown="handleNameKeyDown"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <div :class="[deviceType, 'margin']">
                  <DropDown
                    v-model="prop.personalInformation.dependency"
                    :selectedOption="prop.personalInformation.dependency"
                    :options="dependencyList"
                    :value="dependencyList"
                    field="noOfDependency"
                    :placeholder="
                      t('ccOnBoarding.personalInformation.noOfDependency')
                    "
                  />
                </div>
              </div>
              <div :class="[deviceType, 'flex_half']">
                <DropDown
                  v-model="prop.personalInformation.academic"
                  :selectedOption="prop.personalInformation.academic"
                  :options="academicList"
                  :value="academicList"
                  field="academic"
                  :placeholder="t('ccOnBoarding.personalInformation.academic')"
                />
              </div>
            </div>
            <div
              v-if="prop.personalInformation.academic == '9'"
              :class="[deviceType, 'container']"
            >
              <div :class="[deviceType, 'flex_half']"></div>
              <div :class="[deviceType, 'flex_half']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.personalInformation.otherAcademic"
                  field="otherAcademic"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.personalInformation.otherAcademic')
                  "
                  :max-length="20"
                  :autocomplete="'new-password'"
                />
              </div>
            </div>
          </div>
          <div v-if="prop.type != 'PF_CC'" :class="[deviceType, 'separator']">
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <div :class="[deviceType, 'margin']">
                  <InputText
                    class="inputcomponent"
                    v-model="prop.personalInformation.residentialAddress1"
                    field="residentialAddress1"
                    :required="false"
                    :placeholder="
                      t('ccOnBoarding.personalInformation.residentialAddress1')
                    "
                    :max-length="50"
                    :autocomplete="'new-password'"
                    :disabled="disabledField"
                  />
                </div>
              </div>
              <div :class="[deviceType, 'flex_half']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.personalInformation.residentialAddress2"
                  field="residentialAddress2"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.personalInformation.residentialAddress2')
                  "
                  :max-length="50"
                  :autocomplete="'new-password'"
                  :disabled="disabledField"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <div :class="[deviceType, 'margin']">
                  <InputText
                    class="inputcomponent"
                    v-model="prop.personalInformation.residentialAddress3"
                    field="residentialAddress3"
                    :required="false"
                    :placeholder="
                      t('ccOnBoarding.personalInformation.residentialAddress3')
                    "
                    :max-length="50"
                    :disabled="disabledField"
                  />
                </div>
              </div>
              <div :class="[deviceType, 'flex_half']">
                <InputText
                  v-bind="$attrs"
                  class="inputcomponent"
                  v-model="prop.personalInformation.postCode"
                  field="postCode"
                  :postCode="true"
                  :required="false"
                  :placeholder="t('ccOnBoarding.personalInformation.postCode')"
                  :max-length="5"
                  :autocomplete="'new-password'"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                  :number="'true'"
                  :type="'text'"
                  :inputmode="'numeric'"
                  :pattern="'[0-9]*'"
                  :disabled="disabledField"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <div :class="[deviceType, 'margin']">
                  <InputText
                    :disabled="true"
                    class="inputcomponent"
                    v-model="prop.personalInformation.city"
                    :value="prop.personalInformation.city"
                    field="city"
                    :required="false"
                    :placeholder="t('ccOnBoarding.personalInformation.city')"
                    :autocomplete="'new-password'"
                  />
                </div>
              </div>

              <div :class="[deviceType, 'flex_half']">
                <InputText
                  class="inputcomponent"
                  :disabled="true"
                  v-model="prop.personalInformation.state"
                  :value="prop.personalInformation.state"
                  field="state"
                  :required="false"
                  :placeholder="t('ccOnBoarding.personalInformation.state')"
                  :max-length="21"
                  :autocomplete="'new-password'"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'dropDown']">
                <DropDown
                  v-model="prop.personalInformation.residentialOwnership"
                  :selectedOption="
                    prop.personalInformation.residentialOwnership
                  "
                  :options="ownershipList"
                  :value="ownershipList"
                  field="residentialOwner"
                  :placeholder="
                    t('ccOnBoarding.personalInformation.residentialOwnership')
                  "
                />
              </div>
            </div>
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <div :class="[deviceType, 'margin']">
                  <InputText
                    class="inputcomponent"
                    v-model="prop.personalInformation.yearStay"
                    field="yearStay"
                    :required="false"
                    :placeholder="
                      t('ccOnBoarding.personalInformation.yearOfStay')
                    "
                    :max-length="2"
                    :autocomplete="'new-password'"
                    :type="'text'"
                    :inputmode="'numeric'"
                    :number="'true'"
                    :trim="true"
                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                    @keydown.enter.prevent="handleEnterKey"
                  />
                </div>
              </div>
              <div :class="[deviceType, 'flex_half']">
                <DropDown
                  v-model="prop.personalInformation.monthStay"
                  :selectedOption="prop.personalInformation.monthStay"
                  :options="durationOfStayList"
                  :value="durationOfStayList"
                  :character="true"
                  field="monthStay"
                  :placeholder="
                    t('ccOnBoarding.personalInformation.monthOfStay')
                  "
                />
              </div>
            </div>
          </div>
          <div
            class="brLine"
            v-if="prop.type != 'PF_CC'"
            :class="{
              line: prop.personalInformation.question1 != 'No',
            }"
          >
            <p class="description">
              {{ t("ccOnBoarding.personalInformation.question") }}
            </p>
            <div class="agree">
              <section class="radioClass">
                <RadioButton
                  v-for="option in hrcQuestionnaireEnum"
                  :key="option.value"
                  :label="option.label"
                  :values="option.value"
                  class="radioHorizontal"
                  field="residentialPlace"
                  id="q2"
                  :selected-value="prop.personalInformation.question1"
                  :label-class="'radioLabel'"
                  @selected="question1Selection"
                  :class="{ 'display-flex': true }"
                />
              </section>
            </div>
            <pre class="help" v-if="!errorMessage"> {{ errorMessage }}</pre>
            <pre class="help" v-else-if="error && errorMessage">{{
              errorMessage
            }}</pre>
            <pre class="help" v-else>&nbsp</pre>
          </div>
          <div v-if="prop.personalInformation.question1 == 'No'" class="line">
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <div :class="[deviceType, 'margin']">
                  <InputText
                    class="inputcomponent"
                    v-model="prop.personalInformation.permanentAddress1"
                    field="permanentAddress1"
                    :required="false"
                    :placeholder="
                      t('ccOnBoarding.personalInformation.permanentAddress1')
                    "
                    :max-length="50"
                    :autocomplete="'new-password'"
                  />
                </div>
              </div>
              <div :class="[deviceType, 'flex_half']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.personalInformation.permanentAddress2"
                  field="permanentAddress2"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.personalInformation.permanentAddress2')
                  "
                  :max-length="50"
                  :autocomplete="'new-password'"
                />
              </div>
            </div>

            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <div :class="[deviceType, 'margin']">
                  <InputText
                    class="inputcomponent"
                    v-model="prop.personalInformation.permanentAddress3"
                    field="permanentAddress3"
                    :required="false"
                    :placeholder="
                      t('ccOnBoarding.personalInformation.permanentAddress3')
                    "
                    :max-length="50"
                    :autocomplete="'new-password'"
                  />
                </div>
              </div>
              <div :class="[deviceType, 'flex_half']">
                <InputText
                  v-bind="$attrs"
                  class="inputcomponent"
                  v-model="prop.personalInformation.postCode2"
                  field="permanentPostcode"
                  :postCode="true"
                  :required="false"
                  :placeholder="t('ccOnBoarding.personalInformation.postCode')"
                  :max-length="5"
                  :number="'true'"
                  :type="'text'"
                  :inputmode="'numeric'"
                  :pattern="'[0-9]*'"
                  :autocomplete="'new-password'"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                  @keydown.enter.prevent="handleEnterKey"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <div :class="[deviceType, 'margin']">
                  <InputText
                    class="inputcomponent"
                    v-model="prop.personalInformation.city2"
                    field="permanentCity"
                    :required="false"
                    :disabled="true"
                    :placeholder="t('ccOnBoarding.personalInformation.city')"
                    :autocomplete="'new-password'"
                  />
                </div>
              </div>
              <div :class="[deviceType, 'flex_half']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.personalInformation.state2"
                  field="permanentState"
                  :required="false"
                  :placeholder="t('ccOnBoarding.personalInformation.state')"
                  :autocomplete="'new-password'"
                  :disabled="true"
                />
              </div>
            </div>
          </div>
          <div v-if="prop.type == 'PF_CC'" :class="[deviceType, 'separator']">
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.personalInformation.motherMaidenName"
                  field="motherMaidenName"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.personalInformation.motherMaidenName')
                  "
                  :max-length="100"
                  :autocomplete="'new-password'"
                  @keydown="handleNameKeyDown"
                />
              </div>
              <div :class="[deviceType, 'flex_half']">
                <DropDown
                  v-model="prop.personalInformation.academic"
                  :selectedOption="prop.personalInformation.academic"
                  :options="academicList"
                  :value="academicList"
                  field="academic"
                  :placeholder="t('ccOnBoarding.personalInformation.academic')"
                />
              </div>
            </div>
            <div
              v-if="prop.personalInformation.academic == '9'"
              :class="[deviceType, 'container']"
            >
              <div :class="[deviceType, 'flex_half']"></div>
              <div :class="[deviceType, 'flex_half']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.personalInformation.otherAcademic"
                  field="otherAcademic"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.personalInformation.otherAcademic')
                  "
                  :max-length="20"
                  :autocomplete="'new-password'"
                />
              </div>
            </div>
          </div>
          <div :class="[deviceType, 'buttoncontainer']">
            <button
              v-if="prop.summarySetting.personalInformationJump == false"
              :class="[deviceType, 'left-button']"
              type="button"
              @click="handleBack"
            >
              {{ t("ccOnBoarding.back") }}
            </button>
            <div v-else :class="[deviceType, 'left-button:disabled']"></div>
            <button
              v-if="prop.summarySetting.personalInformationJump == false"
              :class="[deviceType, 'right-button']"
              :disabled="isBtnDisabled"
              @click="handleSubmit"
            >
              {{ t("ccOnBoarding.next") }}
            </button>
            <button
              v-else
              :class="[deviceType, 'summary-button']"
              :disabled="isBtnDisabled"
              @click="handleSubmit"
            >
              {{ t("ccOnBoarding.backToSummary") }}
            </button>
          </div>
        </div>
      </div>
    </Form>
  </div>
  <div v-if="prop.overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  onMounted,
  computed,
  watch,
  watchEffect,
  onBeforeMount,
  type PropType,
} from "vue";
import Headers from "./components/Headers.vue";
import PogressBarStep from "./components/ProgressBarStep.vue";
import DropDown from "./components/NewDropDownComponent.vue";
import InputText from "./components/NewInputTextComponent.vue";
import i18n from "@/plugin/i18n";
import { Form } from "vee-validate";
import RadioButton from "./components/NewRadioButtonComponent.vue";
import hrcQuestionnaireEnum from "@/enum/HRCQuestionnaireEnum";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import { number0_10, number0_11 } from "@/enum/Number";
import type { PersonalInformation } from "@/interface/FormCC";
import type { SummarySetting } from "@/interface/FormCC";
import { deviceDetect } from "mobile-device-detect";
import { popGraphicsState } from "pdf-lib";

const deviceType = ref("");

const prop = defineProps({
  personalInformation: {
    type: Object as PropType<PersonalInformation>,
    required: true,
  },
  nationality: {
    type: String,
    required: true,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  cardName: {
    type: String,
    required: true,
  },
  summarySetting: {
    type: Object as PropType<SummarySetting>,
    required: true,
  },
  type: {
    type: String,
  },
  countDown: {
    type: String,
  },
  webFormRequestId: {
    type: String,
  },
  isAutoPopulate: {
    type: Boolean,
    default: false,
  },
  verification: {
    type: String,
  },
});

const { t } = i18n.global;

const errorMessage = ref("");

//List
const titleList = ref([]);
const genderList = ref([]);
const raceList = ref([]);
const residencyList = ref([]);
const maritalList = ref([]);
const academicList = ref([]);
const ownershipList = ref([]);
const dependencyList = ref(number0_10);
const durationOfStayList = ref(number0_11);
const disabledField = ref(false);

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }

  if (prop.type == "PF_CC") {
    error.value = false;
  }
});

onBeforeMount(() => {
  MasterService.getMasterData()
    .then((res) => {
      titleList.value = res.data.titleType;
      genderList.value = res.data.genderType;
      raceList.value = res.data.raceType;
      residencyList.value = res.data.residencyStatusType;
      maritalList.value = res.data.maritalType;
      academicList.value = res.data.academicQualificationType;
      ownershipList.value = res.data.residencyOwnershipType;
    })
    .catch((e) => {});
  if (prop.nationality != "MY") {
    prop.personalInformation.residencyStatus = "U";
  }

  if (prop.verification == "true" && prop.type == "BIO")
    disabledField.value = true;
});

//PostCode for part1
async function postCodeData() {
  if (prop.personalInformation.postCode.length >= 5 && prop.type != "PF_CC") {
    try {
      const res = await MasterService.checkPostCode(
        prop.personalInformation.postCode
      );
      prop.personalInformation.city = res.data.responseModel.city;
      prop.personalInformation.state = res.data.responseModel.state;
      schema.value.postCode =
        "minLengthNumber:5|maxLengthNumber:5|requiredNumber|numberFormat";
    } catch (e) {
      prop.personalInformation.city = "";
      prop.personalInformation.state = "";
      schema.value.postCode =
        "minLengthNumber:5|maxLengthNumber:5|requiredNumber|invalidPostCode|numberFormat";
    }
  }
}

const getValue = computed(async () => {
  if (prop.personalInformation.postCode.length < 5) {
    prop.personalInformation.city = "";
    prop.personalInformation.state = "";
  } else if (prop.personalInformation.postCode.length >= 5) {
    await postCodeData();
  }

  return {
    city: prop.personalInformation.city,
    state: prop.personalInformation.state,
  };
});

const cityValue = ref("");
const stateValue = ref("");

async function updateValues() {
  const newValues = await getValue.value;
  cityValue.value = newValues.city;
  stateValue.value = newValues.state;
}

watch(getValue, updateValues, { immediate: true });

//PostCode for part2
async function postCode2Data() {
  if (prop.personalInformation.postCode2.length >= 5 && prop.type != "PF_CC") {
    try {
      const res = await MasterService.checkPostCode(
        prop.personalInformation.postCode2
      );
      prop.personalInformation.city2 = res.data.responseModel.city;
      prop.personalInformation.state2 = res.data.responseModel.state;
      if (prop.personalInformation.question1 == "No") {
        const permanentPostcodeValid =
          prop.personalInformation.question1 == "No";
        schema.value.permanentPostcode = permanentPostcodeValid
          ? "minLengthNumber:5|maxLengthNumber:5|requiredNumber|numberFormat"
          : "";
      }
    } catch (e) {
      prop.personalInformation.city2 = "";
      prop.personalInformation.state2 = "";
      if (prop.personalInformation.question1 == "No") {
        const permanentPostcodeValid =
          prop.personalInformation.question1 == "No";
        schema.value.permanentPostcode = permanentPostcodeValid
          ? "minLengthNumber:5|maxLengthNumber:5|requiredNumber|invalidPostCode|numberFormat"
          : "";
      }
    }
  }
}

const getValue2 = computed(async () => {
  if (prop.personalInformation.postCode2.length < 5) {
    prop.personalInformation.city2 = "";
    prop.personalInformation.state2 = "";
  } else if (prop.personalInformation.postCode2.length >= 5) {
    await postCode2Data();
  }

  return {
    city: prop.personalInformation.city2,
    state: prop.personalInformation.state2,
  };
});

const cityValue2 = ref("");
const stateValue2 = ref("");

async function updateValues2() {
  const newValues2 = await getValue2.value;
  cityValue2.value = newValues2.city;
  stateValue2.value = newValues2.state;
}

watch(getValue2, updateValues2, { immediate: true });

const schema = computed(() => {
  const permanent = prop.personalInformation.question1 == "No";
  const other = prop.personalInformation.academic == "9";
  const nationality = prop.nationality == "MY";
  if (prop.type == "PF_CC")
    return {
      motherMaidenName: "required|nameFormat",
      academic: "required",
      otherAcademic: other ? "required" : "",
    };
  else
    return {
      title: "required",
      gender: "required",
      race: "required",
      otherRace: prop.personalInformation.race == "004" ? "required" : "",
      residencyStatus: nationality ? "required" : "",
      maritalSatus: "required",
      motherMaidenName: "required|nameFormat",
      noOfDependency: "required",
      academic: "required",
      otherAcademic: other ? "required" : "",
      residentialAddress1: "required",
      // residentialAddress2: "required",
      postCode:
        "minLengthNumber:5|maxLengthNumber:10|requiredNumber|numberFormat",
      residentialOwner: "required",
      yearStay: "required|maxLengthNumber:10|requiredNumber|numberFormat",
      monthStay: "required",
      residentialPlace: "required",
      permanentAddress1: permanent ? "required" : "",
      // permanentAddress2: permanent ? "required" : "",
      permanentPostcode: permanent
        ? "minLengthNumber:5|maxLengthNumber:5|requiredNumber|numberFormat"
        : "",
    };
});

const handleSubmit = () => {
  if (prop.personalInformation.question1 == "No") {
    schema.value.permanentAddress1 = "required";
    // schema.value.permanentAddress2 = "required";
    schema.value.permanentPostcode =
      "minLengthNumber:5|maxLengthNumber:5|requiredNumber|numberFormat";
  }
};

const defaultResidency = computed(() => {
  return prop.personalInformation.race === "001" && prop.nationality == "MY"
    ? "B"
    : prop.personalInformation.race == "" && prop.nationality == "MY"
    ? ""
    : "U";
});

const error = ref(true);
const question1Selection = (option: string) => {
  prop.personalInformation.question1 = option;
  error.value = false;
};

const isBtnDisabled = computed(() => {
  if (prop.type == "PF_CC") {
    return (
      prop.personalInformation.academic == "" ||
      (prop.personalInformation.academic == "9" &&
        prop.personalInformation.otherAcademic == "") ||
      prop.personalInformation.motherMaidenName == ""
    );
  } else
    return (
      prop.personalInformation.title == "" ||
      prop.personalInformation.gender == "" ||
      prop.personalInformation.race == "" ||
      (prop.personalInformation.race == "004" &&
        prop.personalInformation.otherRace == "") ||
      prop.personalInformation.residencyStatus == "" ||
      prop.personalInformation.maritalStatus == "" ||
      prop.personalInformation.motherMaidenName == "" ||
      prop.personalInformation.dependency == "" ||
      prop.personalInformation.academic == "" ||
      (prop.personalInformation.academic == "9" &&
        prop.personalInformation.otherAcademic == "") ||
      prop.personalInformation.residentialAddress1 == "" ||
      // prop.personalInformation.residentialAddress2 == "" ||
      prop.personalInformation.postCode == "" ||
      prop.personalInformation.city == "" ||
      prop.personalInformation.residentialOwnership == "" ||
      prop.personalInformation.yearStay == "" ||
      prop.personalInformation.monthStay == "" ||
      prop.personalInformation.question1 == "" ||
      (prop.personalInformation.question1 == "No" &&
        (prop.personalInformation.permanentAddress1 == "" ||
          // prop.personalInformation.permanentAddress2 == "" ||
          prop.personalInformation.postCode2 == "" ||
          prop.personalInformation.city2 == ""))
    );
});

const handleKeyDown = (event: KeyboardEvent) => {
  const isDigit = /^[0-9]$/.test(event.key);
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";

  if (
    !isDigit &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey
  ) {
    event.preventDefault();
  }
};

const handleNameKeyDown = (event: KeyboardEvent) => {
  const isSymbol = /^[a-zA-Z@#()_:\/.,'\-\s]+$/.test(event.key);
  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  if (
    !isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const emit = defineEmits(["submit", "jumpStep", "previous-step"]);
const onInvalidSubmit = () => {
  errorMessage.value = "This field is required";
};

const onSubmit = () => {
  emit("submit");
};

const handleBack = () => {
  if (prop.type == "BIO" || prop.type == "FINPLUS") emit("jumpStep", 0, "", 4);
  else emit("jumpStep", 1, "false", 4);
};

watch(
  () => prop.personalInformation.question1,
  (newValue) => {
    if (newValue) {
      prop.personalInformation.permanentAddress1 = "";
      prop.personalInformation.permanentAddress2 = "";
      prop.personalInformation.permanentAddress3 = "";
      prop.personalInformation.postCode2 = "";
    }
  }
);

watch(
  () => prop.personalInformation.academic,
  (newValue) => {
    if (newValue) {
      prop.personalInformation.otherAcademic = "";
    }
  }
);

watch(
  () => prop.personalInformation.race,
  (newValue) => {
    if (newValue) {
      prop.personalInformation.otherRace = "";
    }
  }
);

const handleEnterKey = () => {};
</script>

<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.radioClass {
  display: flex;
  align-items: flex-end;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

.dropDown {
  width: 100%;
}

.container {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.help {
  color: red;
  margin-bottom: 0px;
  font: 400 16px/130% "Outfit", sans-serif;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.flex_half {
  width: 50%;
}

.flex_race {
  width: 50%;
}

.separator {
  margin-bottom: 37px;
}

.summary-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
  transition: background-color 0.3s ease;
}

.summary-button:hover {
  background-image: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0.4),
      rgba(255, 255, 255, 0.4)
    ),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:active {
  background-image: linear-gradient(
      120deg,
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0.3)
    ),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
  transition: background-color 0.3s ease;
}

.right-button:hover {
  background-image: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0.4),
      rgba(255, 255, 255, 0.4)
    ),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.right-button:active {
  background-image: linear-gradient(
      120deg,
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0.3)
    ),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.left-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;
  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.summary-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
}

.inputText {
  margin-bottom: 10px;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

/* .left-button {
  flex: 0 0 15%;
} */

.agree {
  display: flex;
  align-items: flex-start;
}

/* .radioClass {
  display: flex;
} */

.radioHorizontal {
  margin-right: 24px !important;
  color: rgba(0, 0, 0, 0.38);
  margin-bottom: 5px;
}

.description {
  color: #212121;
  font: 500 16px/130% "Outfit";
  margin-bottom: 10px;
  text-align: left;

  position: relative;
  align-self: stretch;
}

.brLine {
  margin-bottom: 8px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

@media (max-width: 700px) {
  .container:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 14px;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }
  .flex_half:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .flex_race:is(.Desktop, .Tablet) {
    width: 100%;
    margin-bottom: 10px;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .summary-button:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .summary-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 0;
  }

  /* .margin:is(.Desktop, .Tablet) {
    margin-bottom: 10px;
  } */
}

.separator .container {
  max-width: none;
}

.content:is(.Mobile) {
  padding: 0;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.container:is(.Mobile) {
  flex-direction: column;
  gap: 14px;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}
.flex_half:is(.Mobile) {
  width: 100%;
}

.flex_race:is(.Mobile) {
  width: 100%;
  margin-bottom: 10px;
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:disabled:is(.Mobile) {
  flex: 0 0 68%;
}

.summary-button:is(.Mobile) {
  flex: 0 0 100%;
}

.summary-button:disabled:is(.Mobile) {
  flex: 0 0 100%;
}

.separator:is(.Mobile) {
  margin-bottom: 0;
}

.margin:is(.Mobile) {
  margin-bottom: 0px;
}
</style>
